import { type ReactElement, type ReactNode } from 'react';
// TEMP (PTV2-1324): Filter only used by the hidden side-nav filters section.
import { FileText, Link2, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Sidebar, type SidebarGroup } from '@/components/shell/Sidebar';

interface BrowseNavSidebarProps {
  /**
   * When true, appends the “All patients” / “Assigned to me” group on the
   * patient list route.
   */
  readonly showPatientFilterGroup?: boolean;
  readonly header?: ReactNode | null;
  readonly footer?: ReactNode | null;
}

/**
 * Left column for all `/browse/*` routes: cohort links (patients /
 * families / questionnaires), optional filter list. Header + user
 * footer come from `Sidebar`'s defaults so the rail looks identical
 * across routes.
 */
export function BrowseNavSidebar({
  // TEMP (PTV2-1324): side-nav filters section hidden for now.
  // showPatientFilterGroup = false,
  header,
  footer,
}: BrowseNavSidebarProps): ReactElement {
  const { t } = useTranslation();

  const cohortGroup: SidebarGroup = {
    key: 'cohorts',
    heading: t('routes.browse.nav.title'),
    items: [
      {
        key: 'patients',
        label: t('routes.browse.sidebar.patients'),
        to: '/browse/patients',
        icon: <Users className="h-4 w-4" aria-hidden="true" />,
      },
      {
        key: 'families',
        label: t('routes.browse.sidebar.families'),
        to: '/browse/families',
        icon: <Link2 className="h-4 w-4" aria-hidden="true" />,
      },
      {
        key: 'questionnaires',
        label: t('routes.browse.sidebar.questionnaires'),
        to: '/browse/questionnaires',
        icon: <FileText className="h-4 w-4" aria-hidden="true" />,
      },
    ],
  };

  // TEMP (PTV2-1324): side-nav filters section hidden for now. Restore this block
  // and the showPatientFilterGroup-based groups logic below.
  // const filterGroup: SidebarGroup = {
  //   key: 'filters',
  //   heading: t('routes.browse.sidebar.filterHeading'),
  //   items: [
  //     {
  //       key: 'all',
  //       label: t('routes.browsePatients.sidebar.all'),
  //       to: '/browse/patients',
  //       matchEnd: true,
  //       icon: <Users className="h-4 w-4" aria-hidden="true" />,
  //     },
  //     {
  //       key: 'mine',
  //       label: t('routes.browsePatients.sidebar.mine'),
  //       to: '/browse/patients/mine',
  //       matchEnd: true,
  //       icon: <Filter className="h-4 w-4" aria-hidden="true" />,
  //     },
  //   ],
  // };

  const groups: readonly SidebarGroup[] = [cohortGroup];

  return <Sidebar groups={groups} header={header} footer={footer} />;
}
